/* eslint-disable camelcase */
import request from '@/utils/request';

export interface UserReq {
    userId: string;
}

export interface UserInfoRes {
    result: number;
    userProfile: {
        bucket: string;
        profile: {
            headurl: string;
            user_name: string;
            kwai_id: string;
        }
    }
}

// 根据 userId 查询用户信息
export const queryUserInfo = async (params: UserReq): Promise<UserInfoRes> => {
    return request
        .post('/rest/o/w/v0/user/profile', params);
};


export interface FollowReqParams {
    page_ref?: number;
    toUserIds: number[]
}

export interface FollowRes {
    result: number;
}

export const batchFollow = async (params: FollowReqParams): Promise<FollowRes> => {
    return request.post('/rest/o/w/relation/batch/follow', {
        page_ref: 142,
        ...params,
    });
};
